import { getServerUrl } from '@utils/environment';
import { useEffect, useState } from 'react';

const authPromiseCache: Record<string, Promise<string>> = {};

const authenticateWithInviteCode = (inviteCode: string): Promise<string> => {
  if (!authPromiseCache[inviteCode]) {
    authPromiseCache[inviteCode] = fetch(
      `${getServerUrl()}/assessment/v1/token`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ invite_code: inviteCode }),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to authenticate');
        }
        return response.json();
      })
      .then((body) => body.token)
      .catch((err) => {
        delete authPromiseCache[inviteCode];
        throw err;
      });
  }
  return authPromiseCache[inviteCode];
};

export const useInviteCodeAuth = () => {
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);
  const [inviteCode, setInviteCode] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(undefined);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('invite_code');
    if (!code) {
      setLoading(false);
      return;
    }

    setInviteCode(code);
    authenticateWithInviteCode(code)
      .then((token) => {
        setAccessToken(token);
      })
      .catch((err) => {
        console.error('Failed to authenticate', err);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    accessToken,
    inviteCode,
    isAuthenticating: loading,
    error,
  };
};
